// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


const HealthCheck = React.createClass({

  render() {
    return (
      <div>
        OKAY
      </div>
    )
  }
})

export default HealthCheck



// WEBPACK FOOTER //
// ./src/scripts/components/HealthCheck.js